import { put, takeEvery } from "redux-saga/effects";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as actionTypes from "./constants";
import { appConfig } from "../../config";
import { push } from "connected-react-router";
import moment from "moment";
import * as actionTypes1 from "../UserPlanSbsrptnWarehseContainer/constants";
var btoa = require("Base64").btoa;

function* fetchmyplans(params) {
  const token = localStorage.getItem("token");
  let page = (params.params && params.params.page) || 1;
  let search = (params.params && params.params.search) || "";
  let filter = (params.params && params.params.filter) || "";

  let filterParam = "";
  if (filter) {
    filterParam = `&orgId=${filter}`;
  }

  try {
    const res = yield fetch(
      `${appConfig.ip}/subscriptnPlan?isActive=true&limit=10&ser=${search}&page=${page}${filterParam}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_MYPLANS_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: actionTypes.FETCH_MYPLANS_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* subscribeBankplan(value) {
  console.log("!!!!!!!!^^^^^^^^^^", value);
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));
  console.log("!!!!!!!!^^^^^^data^^^^", value.datas);
  const data = {
    subscriptnPlan: value.item.item.id,
    runner: value.item.item.user.id,
    runnerOrgId: value.item.item.orgId,
    validityFrom: new Date(),
    validityTo: moment(new Date()).add(value.item.item.validity, "days"),
    orgId: user.orgId,
    userId: user.id,
    paymentType: value.value.paymentType,
    txtnRefNo: value.value.txtnRefNo,
    status: "pending",
    noOfLoads: value.item.item.noOfLoads,
    allocatedLoad: value.item.item.noOfLoads,
    distance: value.item.item.kms,
    allocatedDist: value.item.item.kms,
    currency: value.item.item.crncy.id,
    amount: value.item.item.amount,
    keyword: [user.orgName],
  };

  try {
    const res = yield fetch(`${appConfig.ip}/subscriptn`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {
        throw Object.assign(res, errJSON);
      }
    } else {
      const resJSON = yield res.json();

      if (value.datas[0] && value.datas[0].length > 0) {
        yield put({
          type: actionTypes.EXPIRE_STATUSCHANGE_ACTION,
        });

        const expirydata = {
          ...value.datas[0][0],
          subscriptnPlan: value.datas[0][0].subscriptnPlan.id,
          userId: value.datas[0][0].userId._id,
          runner: value.datas[0][0].runner._id,
          currency: value.datas[0][0].subscriptnPlan.crncy,
          paymentType: value.datas[0][0].paymentType.id,
          status: "expired",
        };

        console.log("!!!!!!!!^^^^^^data^^^^", expirydata);
        try {
          const res = yield fetch(
            `${appConfig.ip}/subscriptn/${value.datas[0][0].id}`,
            {
              method: "PUT",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
              },
              body: JSON.stringify(expirydata),
            }
          );
          if (!res.ok) {
            let errJSON = {};
            try {
              errJSON = yield res.json();
            } catch {}
            throw Object.assign(res, errJSON);
          } else {
            let resJSON = yield res.json();
            yield put({
              type: actionTypes.EXPIRE_STATUSCHANGE_SUCCESS_ACTION,
              payload: resJSON,
            });
          }
        } catch (err) {
          yield put({
            type: actionTypes.EXPIRE_STATUSCHANGE_FAIL_ACTION,
            error: err,
          });
        }
      }

      yield put({
        type: actionTypes.SUBSCRIBE_BANKPLAN_SUCCESS_ACTION,
        payload: resJSON,
      });
      // yield put({ type: actionTypes.FETCH_SUBSCRIPTION_ACTION });
      yield put(push("/mysubscription/mysubscriptions"));
      yield toast.success("New plan subscribed", {
        autoClose: 3000,
        className:"toastClass"
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.SUBSCRIBE_BANKPLAN_FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* subscribeplan(value) {
  console.log("!!!!!!!!^^^^^^^^^^", value);
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));
  console.log("!!!!!!!!^^^^^^data^^^^", value.data);
  try {
    const res = yield fetch(`${appConfig.ip}/payment/razorPayVerfiy`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        razorPaymentId: value.response.razorpay_payment_id,
        razorpayOrderId: value.response.razorpay_order_id,
        signature: value.response.razorpay_signature,
      }),
    });
    if (!res) {
      throw res;
    } else {
      let resJSON = yield res.json();
      if (resJSON.signatureIsValid === true) {
        const data = {
          subscriptnPlan: value.item.item.id,
          runner: value.item.item.user.id,
          runnerOrgId: value.item.item.orgId,
          validityFrom: new Date(),
          validityTo: moment(new Date()).add(value.item.item.validity, "days"),
          orgId: user.orgId,
          userId: user.id,
          noOfLoads: value.item.item.noOfLoads,
          allocatedLoad: value.item.item.noOfLoads,
          distance: value.item.item.kms,
          allocatedDist: value.item.item.kms,
          currency: value.item.item.crncy.id,
          amount: value.item.item.amount,
          paymentType: value.value.paymentType,
          razorpayOrderId: value.response.razorpay_order_id,
          keyword: [user.orgName],
        };
        const res = yield fetch(`${appConfig.ip}/subscriptn`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify(data),
        });
        if (!res) {
          throw res;
        } else {
          let resJSON = yield res.json();
          yield put({
            type: actionTypes.CREATE_INVOICE_ACTION,
          });
          let totalAmount =
          value.item.item.amount + value.item.gst + value.item.gatewayCharge;
          console.log("-----------totalAmount-----", totalAmount);
          const invoicedata = {
            subscriptnId: resJSON.id,
            subscriptnPlanId: value.item.item.id,
            subscriptnNo: resJSON.no,
            creator: value.item.item.user.id,
            reciever: user.id,
            creatorOrgId: value.item.item.orgId,
            recieverOrgId: user.orgId,
            type: "subscription",
            amount: value.item.item.amount ,
            currency: value.item.item.crncy.id,
            gatewayCharge: value.item.gatewayCharge
              ? value.item.gatewayCharge
              : 0,
            gst: value.item.gst ? value.item.gst : 0,
            keyword: [user.orgName, value.item.item.user.orgName],
            status: "paid",
          };
          console.log("-----------invoicedata-----", invoicedata);
          try {
            const res = yield fetch(`${appConfig.ip}/invoice`, {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
              },
              body: JSON.stringify(invoicedata),
            });
            if (!res.ok) {
              let errJSON = {};
              try {
                errJSON = yield res.json();
              } catch {}
              throw Object.assign(res, errJSON);
            } else {
              let resJSON = yield res.json();
              yield put({
                type: actionTypes.CREATE_PAYMENT_ACTION,
              });
              const paymentdata = {
                subscriptnId: resJSON.subscriptnId,
                subscriptnNo: resJSON.subscriptnNo,
                invoiceId: resJSON.id,
                invcNo: resJSON.no,
                reciever: value.item.item.user.id,
                userId: user.id,
                receiverOrgId: value.item.item.orgId,
                orgId: user.orgId,
                status: "paid",
                paymentType: value.value.paymentType,
                currency: value.item.item.crncy.id,
                type: "subscription",
                amount: totalAmount,
                razorPaymentId: value.response.razorpay_payment_id,
              };
              console.log("-----------paymentdata-----", paymentdata);
              try {
                const res = yield fetch(`${appConfig.ip}/payment`, {
                  method: "POST",
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                  },
                  body: JSON.stringify(paymentdata),
                });
                if (!res.ok) {
                  let errJSON = {};
                  try {
                    errJSON = yield res.json();
                  } catch {}
                  throw Object.assign(res, errJSON);
                } else {
                  let resJSON = yield res.json();

                  // =================================================================================
                  if (value.datas && value.datas.length > 0) {
                    yield put({
                      type: actionTypes.EXPIRE_STATUSCHANGE_ACTION,
                    });

                    const expirydata = {
                      ...value.datas[0],
                      subscriptnPlan: value.datas[0].subscriptnPlan.id,
                      userId: value.datas[0].userId._id,
                      runner: value.datas[0].runner._id,
                      currency: value.datas[0].subscriptnPlan.crncy,
                      paymentType: value.datas[0].paymentType.id,
                      status: "expired",
                    };

                    console.log("!!!!!!!!^^^^^^data^^^^", expirydata);
                    try {
                      const res = yield fetch(
                        `${appConfig.ip}/subscriptn/${value.datas[0].id}`,
                        {
                          method: "PUT",
                          headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + token,
                          },
                          body: JSON.stringify(expirydata),
                        }
                      );
                      if (!res.ok) {
                        let errJSON = {};
                        try {
                          errJSON = yield res.json();
                        } catch {}
                        throw Object.assign(res, errJSON);
                      } else {
                        let resJSON = yield res.json();
                        yield put({
                          type: actionTypes.EXPIRE_STATUSCHANGE_SUCCESS_ACTION,
                          payload: resJSON,
                        });
                        // yield put({ type: actionTypes.FETCH_SUBSCRIPTION_ACTION });
                        // yield put(push("/mysubscription/mysubscriptions"));
                        // yield toast.success("Existing subscription expired", {
                        //   autoClose: 3000,
                        // });
                      }
                    } catch (err) {
                      yield put({
                        type: actionTypes.EXPIRE_STATUSCHANGE_FAIL_ACTION,
                        error: err,
                      });
                    }
                  }

                  // =================================================================================

                  yield put({
                    type: actionTypes.CREATE_PAYMENT_SUCCESS_ACTION,
                    payload: resJSON,
                  });
                  // yield put({ type: actionTypes.FETCH_SUBSCRIPTION_ACTION });
                  yield put(push("/mysubscription/mysubscriptions"));
                  yield toast.success("New plan subscribed", {
                    autoClose: 3000,
                    className:"toastClass"
                  });
                }
              } catch (err) {
                yield put({
                  type: actionTypes.CREATE_PAYMENT_FAIL_ACTION,
                  error: err,
                });
              }
              yield put({
                type: actionTypes.CREATE_INVOICE_SUCCESS_ACTION,
                payload: resJSON,
              });
            }
          } catch (err) {
            yield put({
              type: actionTypes.CREATE_INVOICE_FAIL_ACTION,
              error: err,
            });
          }
          yield put({
            type: actionTypes.SUBSCRIBE_PLAN_SUCCESS_ACTION,
            payload: resJSON,
          });
          yield put({
            type: actionTypes1.WAREHOUSESUBSCRIBE_PLAN_SUCCESS_ACTION,
            payload: resJSON,
          });
        }
      } else {
        yield toast.error("Payment Failed", {
          autoClose: 3000,
          className:"toastClass"
        });
      }
    }
  } catch (err) {
    yield put({
      type: actionTypes.SUBSCRIBE_PLAN_FAIL_ACTION,
      error: err,
    });
  }
}

function* fetchSubscription(params) {
  const token = localStorage.getItem("token");
  let page = (params.params && params.params.page) || 1;
  let search = (params.params && params.params.search) || "";
  let user = JSON.parse(localStorage.getItem("user"));
  let filter = (params.params && params.params.filter) || "";
  let secfilter = (params.params && params.params.secfilter) || "";

  let searchParam = "";
  if (search) {
    searchParam = `&ser=${search}`;
  }

  let filterParam = "";
  if (filter) {
    filterParam = `&runnerOrgId=${filter}`;
  }
  let secfilterParam = "";
  if (secfilter) {
    secfilterParam = `&status=${secfilter}`;
  }
  let id = user.orgId;
  try {
    const res = yield fetch(
      `${appConfig.ip}/subscriptn?status=active,pending&orgId=${id}&limit=10&page=${page}${filterParam}${searchParam}${secfilterParam}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_SUBSCRIPTION_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_SUBSCRIPTION_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* deleteSubscription(value) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));

  let id = value.value.item.id;
  let data = {
    userId: user.id,
  };

  try {
    const res = yield fetch(`${appConfig.ip}/subscriptn/` + id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ data }),
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      yield put({ type: actionTypes.SUBSCRIBE_PLAN_ACTION });
      yield put({
        type: actionTypes.DELETE_SUBSCRIPTION_SUCCESS_ACTION,
        payload: id,
      });
      yield toast.success("Subscription deleted successfully", {
        autoClose: 3000,
        className:"toastClass"
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.DELETE_SUBSCRIPTION_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchPaymentmode() {
  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(`${appConfig.ip}/paymentMode?type=subscription`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_SUB_PAYMENTMODE_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_SUB_PAYMENTMODE_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchrunnerById(params) {
  let id = params.item.item.user.id;
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/licenseeProf/${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_RUNNER_BYID_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_RUNNER_BYID_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchRunners() {
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/users?role=runner`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      let runnerdtlList = resJSON.rows.map((data) => {
        let runnerdtlLists = {
          value: data.orgId,
          name: data.orgName,
        };

        return runnerdtlLists;
      });

      yield put({
        type: actionTypes.FETCH_RUNNER_USER_SUCCESS_ACTION,
        payload: resJSON,
        runnerdtlList: runnerdtlList,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_RUNNER_USER_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchSubscriptionLog(value) {
  const token = localStorage.getItem("token");
  let page = (value.params && value.params.page) || 1;
  let id = value.item;
  try {
    const res = yield fetch(
      `${appConfig.ip}/subscriptionlog?subscriptnId=${id}&limit=5&page=${page}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_SUBSCRIPTION_LOG_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_SUBSCRIPTION_LOG_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchTotalSubsrptn(value) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));

  let id = value.item.item.orgId;
  let userId = user.id;
  try {
    const res = yield fetch(
      `${appConfig.ip}/subscriptn?runnerOrgId=${id}&userId=${userId}&status=active,pending`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_TOTALSUBSCRPTN_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_TOTALSUBSCRPTN_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchLog() {
  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(`${appConfig.ip}/subscriptionlog`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.SUBSCRIBE_LOG_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.SUBSCRIBE_LOG_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchSubCargoSize() {
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/loadMetrics?isActive=true`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_SUB_CARGOSIZE_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_SUB_CARGOSIZE_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

// function* expiryStatusChange(value) {
//   console.log("!!!!!!!!!!!!!!value", value);
//   const token = localStorage.getItem("token");
//   let user = JSON.parse(localStorage.getItem("user"));
//   let data = {
//     ...value.item[0],
//     subscriptnPlan: value.item[0].subscriptnPlan.id,
//     userId: value.item[0].userId._id,
//     runner: value.item[0].runner._id,
//     currency: value.item[0].subscriptnPlan.crncy,
//     paymentType: value.item[0].paymentType.id,
//     status: "expired",
//   };
//   console.log("!!!!!!!!!!!!!data", data);

//   try {
//     const res = yield fetch(`${appConfig.ip}/subscriptn/${value.item[0].id}`, {
//       method: "PUT",
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//       },
//       body: JSON.stringify(data),
//     });

//     if (!res.ok) {
//       let errJSON = {};
//       try {
//         errJSON = yield res.json();
//       } catch {
//         throw Object.assign(res, errJSON);
//       }
//     } else {
//       const resJSON = yield res.json();

//       yield put({
//         type: actionTypes.EXPIRE_STATUSCHANGE_SUCCESS_ACTION,
//         payload: resJSON,
//       });
//       yield toast.success("Existing subscription expired", {
//         autoClose: 3000,
//       });
//     }
//   } catch (err) {
//     if (err.ok === false) {
//       yield put({
//         type: actionTypes.EXPIRE_STATUSCHANGE_FAIL_ACTION,
//         error: err,
//       });
//     }
//   }
// }

function* fetchHistorySubscription(params) {
  const token = localStorage.getItem("token");
  let page = (params.params && params.params.page) || 1;
  let search = (params.params && params.params.search) || "";
  let user = JSON.parse(localStorage.getItem("user"));
  let filter = (params.params && params.params.filter) || "";
  let secfilter = (params.params && params.params.secfilter) || "";
  let searchParam = "";
  if (search) {
    searchParam = `&ser=${search}`;
  }

  let filterParam = "";
  if (filter) {
    filterParam = `&runnerOrgId=${filter}`;
  }
  let secfilterParam = "";
  if (secfilter) {
    secfilterParam = `&status=${secfilter}`;
  }
  let id = user.orgId;
  try {
    const res = yield fetch(
      `${appConfig.ip}/subscriptn?status=expired,cancelled&orgId=${id}&limit=10&page=${page}${filterParam}${searchParam}${secfilterParam}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_HISTORYSUBSCRIPTION_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_HISTORYSUBSCRIPTION_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

export function* MySubscriptionActionWatcher() {
  yield takeEvery(actionTypes.FETCH_MYPLANS_ACTION, fetchmyplans);
  yield takeEvery(actionTypes.SUBSCRIBE_PLAN_ACTION, subscribeplan);
  yield takeEvery(actionTypes.FETCH_SUBSCRIPTION_ACTION, fetchSubscription);
  yield takeEvery(actionTypes.DELETE_SUBSCRIPTION_ACTION, deleteSubscription);
  yield takeEvery(actionTypes.FETCH_SUB_PAYMENTMODE_ACTION, fetchPaymentmode);
  yield takeEvery(actionTypes.FETCH_RUNNER_BYID_ACTION, fetchrunnerById);
  yield takeEvery(actionTypes.SUBSCRIBE_BANKPLAN_ACTION, subscribeBankplan);
  yield takeEvery(actionTypes.FETCH_RUNNER_USER_ACTION, fetchRunners);
  yield takeEvery(
    actionTypes.FETCH_SUBSCRIPTION_LOG_ACTION,
    fetchSubscriptionLog
  );
  yield takeEvery(actionTypes.FETCH_TOTALSUBSCRPTN_ACTION, fetchTotalSubsrptn);
  yield takeEvery(actionTypes.SUBSCRIBE_LOG_ACTION, fetchLog);
  yield takeEvery(actionTypes.FETCH_SUB_CARGOSIZE_ACTION, fetchSubCargoSize);
  // yield takeEvery(actionTypes.EXPIRE_STATUSCHANGE_ACTION, expiryStatusChange);

  yield takeEvery(
    actionTypes.FETCH_HISTORYSUBSCRIPTION_ACTION,
    fetchHistorySubscription
  );
}
